// extracted by mini-css-extract-plugin
export default {"root":"t3vTUMy7"};